import { SubAPI } from "./SubAPI";
export class Companies extends SubAPI {
    list(props) { return this.fetcher.get("/api/companies", props); }
    get(props) { return this.fetcher.get("/api/company", props); }
    upsert(input) { return this.fetcher.post("/api/company", input); }
}
